import React from 'react'
import { observer } from 'mobx-react-lite'

import { AppLogo } from '@/Ship/Components/UI/AppLogo/AppLogo'
import { themeStore } from '@/Ship/Stores/ThemeStore'

import styles from './DefaultLoadTemplate.module.css'

/** Екран завантаження: логотип на фоні поточної теми, літери під тон фону */
export const DefaultLoadTemplate: React.FC = observer(() => {
    return (
        <div className={styles['preloader']}>
            <div className={styles['wrapLogo']}>
                <AppLogo tone={themeStore.mode === 'light' ? 'dark' : 'light'} />
            </div>
        </div>
    )
})
